export const LOAD_CUSTOMER_INFORMATION = "LOAD_CUSTOMER_INFORMATION";
export const LOAD_CUSTOMER_INFORMATION_SUCCESS = "LOAD_CUSTOMER_INFORMATION_SUCCESS";
export const LOAD_CUSTOMER_INFORMATION_FAILED = "LOAD_CUSTOMER_INFORMATION_FAILED";


// WEBPACK FOOTER //
// ./src/customer-information/customerInformationActionTypes.js